import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class InterpolationService {
constructor() { }

  public interpolate(data: any, dataMap: Map<string, any> = new Map()): any {
    if (!data) {
        return data;
    }

    if (Array.isArray(data)) {
        return data.map(value => this.interpolate(value, dataMap));
    }

    if (typeof data === 'string') {
        let result = data;

        dataMap.forEach((value, key) => {
        result = result.replace(`{{${key}}}`, value);
        });

        return result;
    }

    Object.keys(data).forEach(key => {
        data[key] = this.interpolate(data[key], dataMap);
    });

    return data;
  }
}
